
   <div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="saving">
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
   
   <mat-stepper linear #stepper
    [orientation]="(stepperOrientation | async)!">
    <mat-step state="done" *ngIf="profileForm" [completed]="profileForm?.valid" [stepControl]="profileForm" label="Personal Particulars">
        <mat-card class="m-3">
            <mat-card-header>
              <mat-card-title class="mt-3">Patient Details</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form class="user" [formGroup]="profileForm" (ngSubmit)="saveProfile()">
                    <div class="d-flex row p-3">
                  <div class="col-md-6 d-flex flex-column">
                      <mat-form-field appearance="outline">
                          <mat-label>Name</mat-label>
                          <input matInput placeholder="Name" name="name" formControlName="Name">
                          <mat-error *ngIf="profileForm.controls.Name.invalid">Name is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Surname</mat-label>
                          <input matInput placeholder="Surname" formControlName="Surname">
                          <mat-error *ngIf="profileForm.controls.Surname.invalid">Surname is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="!profile.ID" appearance="outline">
                          <mat-label>ID</mat-label>
                          <input matInput placeholder="ID" formControlName="ID">
                          <mat-error *ngIf="profileForm.controls.ID.invalid">ID is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Occupation</mat-label>
                          <input matInput placeholder="Occupation" formControlName="Occupation">
                          <mat-error *ngIf="profileForm.controls.Occupation.invalid">Occupation is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Title</mat-label>
                        <input matInput placeholder="Title" formControlName="Title">
                        <mat-error *ngIf="profileForm.controls.Title.invalid">Title is Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Gender</mat-label>
                        <input matInput placeholder="Gender" formControlName="Gender">
                        <mat-error *ngIf="profileForm.controls.Gender.invalid">Gender is Required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 d-flex flex-column">
                      <mat-form-field appearance="outline">
                          <mat-label>Address</mat-label>
                          <input matInput placeholder="Address" formControlName="Address">
                          <mat-error *ngIf="profileForm.controls.Occupation.invalid">Address is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Mobile</mat-label>
                          <input matInput placeholder="Mobile" formControlName="Mobile">
                          <mat-error *ngIf="profileForm.controls.Occupation.invalid">Mobile is Required</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Email</mat-label>
                          <input matInput placeholder="Email" formControlName="Email">
                          <mat-error *ngIf="profileForm.controls.Occupation.invalid">Email is Required</mat-error>
                      </mat-form-field>
                  </div>
                </div>
                <mat-toolbar class="d-flex justify-content-end">
                    <button type="submit" [disabled]="!profileForm.valid || saving" mat-raised-button color="primary">
                      {{ profileForm.dirty ? 'Save' : 'Next' }}
                    </button>
                  </mat-toolbar>
                </form>
            </mat-card-content>
          </mat-card>
    </mat-step>
    <mat-step *ngIf="medicalForm" [completed]="medicalForm.valid" [stepControl]="medicalForm" label="Medical Aid Details">
        <mat-card class="m-3">
            <mat-card-header>
              <mat-card-title class="mt-3">Medical Aid Details</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form class="user" [formGroup]="medicalForm" (ngSubmit)="saveMedicalDetails()">
                <div class="row d-flex p-3">
                
                  <div class="col-md-6 d-flex flex-column">
                      <mat-form-field appearance="outline">
                          <mat-label>MedicalAidName</mat-label>
                          <input matInput placeholder="MedicalAidName" formControlName="MedicalAidName">
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>MedicalAidNumber</mat-label>
                          <input matInput placeholder="MedicalAidNumber" formControlName="MedicalAidNumber">
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>MedicalAidMainMember</mat-label>
                          <input matInput placeholder="MedicalAidMainMember" formControlName="MedicalAidMainMember">
                      </mat-form-field>
                  </div>
                  <div class="col-md-6 d-flex flex-column">
                      <mat-form-field appearance="outline">
                          <mat-label>ReferredBy</mat-label>
                          <input matInput placeholder="ReferredBy" formControlName="ReferredBy">
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>HealthProblems</mat-label>
                          <input matInput placeholder="HealthProblems" formControlName="HealthProblems">
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Notes</mat-label>
                          <input matInput placeholder="Notes" formControlName="Notes">
                      </mat-form-field>
      
                  </div>
                </div>
                <mat-toolbar class="d-flex justify-content-between">
                    <button type="button" mat-button (click)="back()">
                        Back
                      </button>
                    <button type="submit" [disabled]="!medicalForm.valid || saving" mat-raised-button color="primary">
                        {{ medicalForm.dirty ? 'Save' : 'Next' }}
                    </button>
                  </mat-toolbar>
                </form>
            </mat-card-content>
          </mat-card>
    </mat-step>
    <mat-step *ngIf="profile" [completed]="profile.Document && profile.Document.name" [stepControl]="thirdFormGroup" label="Patient Consent">
        <app-patient-consent-form (emitBack)="back()" [patient]="profile" (emitPatient)="savePatientConsent($event)"></app-patient-consent-form>
    </mat-step>
  </mat-stepper>